import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCard from './FeatureCard';
import { Target, BarChart, Brain, Search, FileText, Briefcase } from 'lucide-react';

const FeaturesSection: React.FC = () => {
  const { t } = useTranslation();
  const features = t('landing.features.features', { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const featureIcons = [Target, BarChart, Brain];

  return (
    <section id="features" className="py-20 bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('landing.features.title').includes('Nos Fonctionnalités') ? (
              <>
                Nos{' '}
                <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                  Fonctionnalités
                </span>{' '}
                <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  Avancées
                </span>
              </>
            ) : (
              <>
                Our{' '}
                <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                  Advanced
                </span>{' '}
                <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  Features
                </span>
              </>
            )}
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            {t('landing.features.subtitle').includes('Découvrez') ? (
              <>
                Découvrez la puissance de{' '}
                <span className="text-indigo-400 font-semibold">CVMatch Swiss</span>{' '}
                pour analyser votre CV
              </>
            ) : (
              <>
                Discover the power of{' '}
                <span className="text-indigo-400 font-semibold">CVMatch Swiss</span>{' '}
                for CV analysis
              </>
            )}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={featureIcons[index]}
              title={feature.title}
              description={feature.description}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;